import { lazy } from 'react';

// Transactions page with virtual scrolling
export const LazyTransactions = lazy(() => 
  import(/* webpackChunkName: "transactions" */ '@/pages/Transactions')
    .then(module => ({ default: module.Transactions }))
);
